import { IMapInstance, IMapProvider, MapInitOptions } from "../map-provider.interface";
import { GoogleMapInstance } from "./google-map-instance";
import { GoogleMapsLoader } from "./google-maps-loader";

export type GoogleProviderOptions = {
    apiKey: string;
};

export class GoogleProvider implements IMapProvider {
    private readonly _apiKey: string;

    constructor(options: GoogleProviderOptions) {
        this._apiKey = options.apiKey;
    }

    async createMap(container: HTMLElement, options: MapInitOptions): Promise<IMapInstance> {
        const loader = GoogleMapsLoader.getLoader(this._apiKey);

        const { Map } = await loader.importLibrary("maps");

        const map = new Map(container, {
            mapId: options.mapId,
            zoom: options.zoom,
            center: options.center,
            gestureHandling: options.gestureHandling,
            disableDefaultUI: options.disableDefaultUI ?? true,
        });

        return new GoogleMapInstance(map, loader);
    }
}